import Immutable from "immutable";
import { ResponseRecord, createMessageRecord } from "reducers/responses/reducer";
import generateUUID from "services/generate-uuid";

const newResponseModalState = Immutable.Map({
  response: new ResponseRecord({
    new: true
  })
});

/**
 * @param {Immutable.Map<string, unknown>} state
 * @returns {Immutable.Map<string, unknown>}
 */
function setMetaData(state) {
  return state.mergeIn(["response"], {
    isValid: Boolean(state.getIn(["response", "handle"]).length),
    isDirty: true
  });
}

export const newResponseModal = (state = newResponseModalState, action) => {
  switch (action.type) {
    case "CREATE_RESPONSE": {
      let newState = state;

      let newResponse = new ResponseRecord(
        Immutable.fromJS({
          handle: action.handle,
          search: action.search,
          saved: true,
          buttonLabel: Immutable.Map({
            [action.language]: null
          }),
          messages: Immutable.Map({
            [action.language]: Immutable.List([
              createMessageRecord({
                type: "text",
                body: "Hello"
              })
            ])
          }),
          options: Immutable.Map({
            [action.language]: Immutable.List([])
          }),
          new: true,
          id: generateUUID(),
          reviewable: action.reviewable
        })
      );

      if (!action.reviewable) {
        let defaultOptions = Immutable.List([]);
        const didHelpResponseId = action.clientResponses.get("did Help");
        const didntHelpResponseId = action.clientResponses.get("didn't Help");

        if (didHelpResponseId) {
          defaultOptions = defaultOptions.push(didHelpResponseId);
        }

        if (didntHelpResponseId) {
          defaultOptions = defaultOptions.push(didntHelpResponseId);
        }

        newResponse = newResponse.updateIn(
          ["options", action.language],
          (arr) => {
            const optionsToAdd = defaultOptions.map((optionId) => {
              if (!arr.includes(optionId) && !newResponse.reserved) {
                return Immutable.Map({
                  target: optionId,
                  label: ""
                });
              }

              return null;
            });

            return arr.concat(optionsToAdd);
          }
        );
      }

      newState = newState.set("response", newResponse);

      return setMetaData(newState);
    }

    case "UPDATE_NEW_RESPONSE":
      return setMetaData(
        state.mergeIn(["response"], action.payload)
      );

    case "ADD_BUTTON_LABEL_LANGUAGE_TO_NEW_RESPONSE":
      return setMetaData(
        state.setIn(["response", "buttonLabel", action.languageCode], "")
      );

    case "DELETE_BUTTON_LABEL_LANGUAGE_TO_NEW_RESPONSE":
      return setMetaData(
        state.deleteIn(["response", "buttonLabel", action.languageCode])
      );

    case "ADD_TAG_TO_NEW_RESPONSE":
      return setMetaData(
        state.updateIn(["response", "tags"], arr => arr.push(action.tagId))
      );

    case "REMOVE_TAG_FROM_NEW_RESPONSE":
      return setMetaData(
        state.updateIn(["response", "tags"], arr => arr.filter(tagId => tagId !== action.tagId))
      );

    case "CREATE_TAG_SUCCESS": {
      if (!action.responseRecord.get("new")) {
        return state;
      }

      return setMetaData(
        state.updateIn(["response", "tags"], arr => arr.push(action.response.data.tag._id))
      );
    }

    default:
      return state;
  }
};
